import { useEffect, useState } from 'react';
import useQueryString from '../components/hooks/useQueryString';
import useClientWindowDimensions from '../components/hooks/useWindowDimensions';
import styles from './debug-grid.module.less';

export const DebugGrid = () => {
    const [isMounted, setIsMounted] = useState(false);
    const [{ showDebugGrid }] = useQueryString();
    const { width } = useClientWindowDimensions();

    useEffect(() => {
        setIsMounted(true);
    }, []);

    if (!showDebugGrid || !isMounted) {
        return null;
    }

    const numColumns = resolveViewportWidthToGridColumns(width);

    return (
        <div className={styles.displayGridWrapper}>
            <div className={styles.displayGrid}>
                {new Array(parseInt(numColumns, 10)).fill().map((_, index) => {
                    return <div className={styles.gridColumn} key={index} />;
                })}
            </div>
        </div>
    );
};

const resolveViewportWidthToGridColumns = (viewportWidth) => {
    if (viewportWidth >= 1024) {
        return 12;
    }
    if (viewportWidth >= 768) {
        return 6;
    }
    return 4;
};
